import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VTooltip from "v-tooltip";
import firebase from "firebase";
import store from "./store";

Vue.use(VTooltip);
Vue.config.productionTip = false;

let app = null;

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});

Vue.directive('visible', function(el, binding) {
	el.style.opacity = binding.value ? 1 : 0;
});
